import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const FloatingImages = () => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                position: 'absolute',
                width: '100%',
                height: '100%',
                top: 0,
                left: 0,
                pointerEvents: 'none',
                overflow: 'hidden',
                zIndex: 100,
            }}
        >
            <Box
                component="img"
                src="/assets/chekup/ia.png"
                alt={t('heroFloatingElement1')}
                sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px',
                    position: 'absolute',
                    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                    padding: '2px',
                    top: '20%',
                    left: '15%',
                    width: '180px',
                    height: 'auto',
                    animation: 'float1 8s ease-in-out infinite',
                    '@keyframes float1': {
                        '0%, 100%': {
                            transform: 'translateY(0) rotate(0deg)',
                        },
                        '50%': {
                            transform: 'translateY(-20px) rotate(5deg)',
                        },
                    },
                }}
            />
            <Box
                component="img"
                src="/assets/chekup/garage.jpeg"
                alt={t('heroFloatingElement2')}
                sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px',
                    position: 'absolute',
                    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                    top: '40%',
                    right: '2%',
                    width: '225px',
                    height: 'auto',
                    animation: 'float2 10s ease-in-out infinite',
                    '@keyframes float2': {
                        '0%, 100%': {
                            transform: 'translateY(0) rotate(0deg)',
                        },
                        '50%': {
                            transform: 'translateY(-15px) rotate(-3deg)',
                        },
                    },
                }}
            />
            <Box
                component="img"
                src="/assets/chekup/period.png"
                alt={t('heroFloatingElement3')}
                sx={{
                    backgroundColor: '#FFFFFF',
                    borderRadius: '10px',
                    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                    position: 'absolute',
                    bottom: '25%',
                    left: '20%',
                    width: '80px',
                    padding: '1px',
                    height: 'auto',
                    animation: 'float3 12s ease-in-out infinite',
                    '@keyframes float3': {
                        '0%, 100%': {
                            transform: 'translateY(0) rotate(0deg)',
                        },
                        '50%': {
                            transform: 'translateY(-25px) rotate(2deg)',
                        },
                    },
                }}
            />
        </Box>
    );
};

export default FloatingImages; 